import React, { useState } from "react";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { createLink } from "../../store/reducers/paymentsReducer";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CopyText from "../common/others/CopyText";
import OpacityLoading from "../common/loader/OpacityLoading";
import { editUserById } from "../../store/reducers/userReducer";
import { getInviteLink } from "../../store/reducers/dataReducer";
import whatsapp from "../../assets/common/whatsapp.svg";

const Stats = ({ user }) => {
  const { isItay } = useSelector((state) => state.authReducer.user);
  const dispatch = useDispatch();
  let sum = 0;
  let sumS = 0;
  let itay = 0;
  let seatup = 0;
  let sms = parseFloat(0.01 * user.smsCounter * 1.17).toFixed(2);
  let wha = parseFloat(0.17 * user.whaCounter * 1.17).toFixed(2);
  // let calls = parseFloat(user.talsCounter);
  let calls = parseFloat(user.restRecordsAtFirstCall) * parseFloat(1.2);
  let records1 = (parseFloat(user.deal) * parseFloat(user.records)).toFixed(2);
  let records = (1.5 * parseFloat(user.records)).toFixed(2);
  let paybox =
    user.paybox !== "" && user.paybox !== null ? parseFloat(user.giftCost) : 0;
  let payboxTax = parseFloat(user.payboxTax);
  let digitalSeatCost = user.isDigitalSeat
    ? parseFloat(user.digitalSeatCost)
    : 0;
  sum =
    parseFloat(records) +
    parseFloat(paybox) +
    parseFloat(payboxTax) +
    parseFloat(digitalSeatCost);
  sumS =
    parseFloat(records1) +
    parseFloat(paybox) +
    parseFloat(payboxTax) +
    parseFloat(digitalSeatCost);
  let expenses = parseFloat(sms) + parseFloat(wha) + parseFloat(calls);
  let itayProfit = parseFloat(
    (parseFloat(sum) - parseFloat(expenses)) / 2
  ).toFixed(2);
  itay =
    (parseFloat(itayProfit) + parseFloat(expenses)).toFixed(2) -
    parseFloat(payboxTax);
  let seatupProfit = (parseFloat(sumS) - parseFloat(itay)).toFixed(2);
  const [price, setPrice] = useState(parseFloat(itay) + parseFloat(seatup));
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCreateLink = async () => {
    if (user.isPaid) {
      setLoading(true);
      dispatch(editUserById(user._id, { itay })).then((res) => {
        setLoading(false);
        if (res.payload?.error) toast.error(res.payload?.error);
        else
          toast.success(
            <div>
              <div>{`צריך להעביר לאיתי ${parseFloat(itay).toFixed(2)}`}</div>
              <div>{`רווחים נקיים של איתי ${parseFloat(itayProfit).toFixed(
                2
              )}`}</div>
              <div>{`רווחים נקיים של סיטאפ ${parseFloat(seatupProfit).toFixed(
                2
              )}`}</div>
            </div>,
            {
              autoClose: 50000,
            }
          );
      });
    } else toast.warning("לא ניתן להפריש אם הכסף עוד לא שולם");
  };

  const handleGetLink = async () => {
    dispatch(getInviteLink({ uid: user._id })).then((res) => {
      setLoading(false);
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <div>
            <FlexRowBetween>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://wa.me/972${user.phone}/?text=`}
              >
                <img
                  src={whatsapp}
                  alt={"whatsapp"}
                  style={{ width: "31px" }}
                />
              </a>
              <CopyText
                marginLeft={"5px"}
                dataToCopy={res.payload}
                text={"קישור כללי"}
              />
            </FlexRowBetween>
          </div>
        );
    });
  };

  const handleClick = (e) => {
    if (e.type === "contextmenu") toast.info(itay);
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
      style={{ padding: "20px" }}
    >
      <table style={{ textAlign: "center", width: "90%", margin: "0 auto" }}>
        <tr>
          <th></th>
          <th>כמות</th>
          <th>מחיר (₪)</th>
          <th style={{ width: "max-content" }}>סה״כ (₪)</th>
        </tr>

        <tr>
          <th>sms</th>
          <td>{user.smsCounter}</td>
          <td>0.01</td>
          <td style={{ background: "#ec707035" }}>{sms}</td>
        </tr>

        <tr>
          <th>ווצאפ</th>
          <td>{user.whaCounter}</td>
          <td>0.15</td>
          <td style={{ background: "#ec707035" }}>{wha}</td>
        </tr>

        {isItay && (
          <tr>
            <th>שיחות</th>
            <td></td>
            <td></td>
            <td style={{ background: "#ec707035" }}>
              {parseFloat(user.talsCounter).toFixed(2)}
            </td>
          </tr>
        )}

        <tr>
          <th>שיחות</th>
          <td>{user.restRecordsAtFirstCall}</td>
          <td>1.2</td>
          <td style={{ background: "#ec707035" }}>
            {(
              parseFloat(user.restRecordsAtFirstCall) * parseFloat(1.2)
            ).toFixed(2)}
          </td>
        </tr>
        <tr>
          <th>מקדמה</th>
          <td></td>
          <td></td>
          <td style={{ background: "#e1f7e7" }}>{user.mikdama}</td>
        </tr>
        <tr>
          <th>רשומות</th>
          <td>{user.records}</td>
          <td>{user.deal}</td>
          <td style={{ background: "#e1e9f7" }}>{records1}</td>
        </tr>

        <tr>
          <th>מתנות באשראי</th>
          <td>{user.paybox !== "" && user.paybox !== null ? 1 : 0}</td>
          <td>{user.giftCost}</td>
          <td style={{ background: "#e1e9f7" }}>{paybox}</td>
        </tr>

        <tr>
          <th>הושבה</th>
          <td>{user.isDigitalSeat ? 1 : 0}</td>
          <td>{user.digitalSeatCost}</td>
          <td style={{ background: "#e1e9f7" }}>{digitalSeatCost}</td>
        </tr>

        <tr>
          <th>עמלות אשראי</th>
          <td></td>
          <td></td>
          <td style={{ background: "#e1e9f7" }}>{payboxTax}</td>
        </tr>
      </table>

      <FlexRowBetween style={{ marginTop: "30px", alignItems: "flex-end" }}>
        {/* <div style={{ width: "40%" }}>
          <Label onContextMenu={handleClick}>סכום לתשלום (₪)</Label>
          <Input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div> */}
        {/* <GenericDiv onClick={handleCreateLink}>יצירת לינק</GenericDiv> */}
        {/* {link ? (
          <CopyText marginLeft={"5px"} dataToCopy={link} text={"העתקת הלינק"} />
        ) : (
          <GenericDiv onClick={handleCreateLink}>יצירת לינק לתשלום</GenericDiv>
        )} */}
        {/* {user.itay === 0 && isItay && ( */}
        <GenericDiv onClick={handleCreateLink}>חישוב</GenericDiv>
        <GenericDiv onClick={handleGetLink}>לינק כללי</GenericDiv>

        {/* )} */}
        {/* {user.itay === 0 && isItay && <GenericDiv>{user.itay}</GenericDiv>} */}
      </FlexRowBetween>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default Stats;
